import { useMemo } from "react";

import { ReceiptProvider } from "../services";
import {
	ReceiptBindingTarget,
	ReceiptSystemProviderEnum,
} from "../services/ReceiptProvider/types";
import { useTypedSelector } from "../redux/store";

export function computeReceiptBindingAvailability(
	providers: ReceiptProvider.Model[],
	taxiServiceId?: number | null,
	taxId?: string | null,
): {
	showExecutorReceipts: boolean;
	showCarReceipts: boolean;
	requiresTaxId: boolean;
	hasTaxId: boolean;
} {
	if (!taxiServiceId) {
		return {
			showExecutorReceipts: false,
			showCarReceipts: false,
			requiresTaxId: false,
			hasTaxId: Boolean(String(taxId ?? "").trim()),
		};
	}

	let showExecutorReceipts = false;
	let showCarReceipts = false;
	let requiresTaxId = false;

	const activeProviders = providers.filter((provider) => provider?.active);

	for (const provider of activeProviders) {
		const branchIds = provider.taxiServiceIds ?? [];

		if (branchIds.includes(taxiServiceId)) {
			if (provider.bindingTarget === ReceiptBindingTarget.EXECUTOR) {
				showExecutorReceipts = true;
				if (provider.provider === ReceiptSystemProviderEnum.FISCAL_PARTNER) {
					requiresTaxId = true;
				}
			}
			if (provider.bindingTarget === ReceiptBindingTarget.CAR) {
				showCarReceipts = true;
			}
		}
	}

	return {
		showExecutorReceipts,
		showCarReceipts,
		requiresTaxId,
		hasTaxId: Boolean(String(taxId ?? "").trim()),
	};
}

export default function useReceiptBindingAvailability(
	taxiServiceId?: number | null,
	taxId?: string | null,
) {
	const providers = useTypedSelector(
		(state) => state.settingsReceiptProvider.data,
	);

	return useMemo(
		() =>
			computeReceiptBindingAvailability(
				providers,
				taxiServiceId,
				taxId,
			),
		[providers, taxiServiceId, taxId],
	);
}
